import { useState } from 'react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../../../../../App/redux/store';
import Button from '../../../../../../../components/Assets/Button';
import Map from '../../../../../../../shared/components/map/Map';
import { getAdState } from '../../../../../adSlice';
import AdMarkers from '../AdMarkers';
import MapLegend from '../mapLegend/MapLegend';
import styles from './AdDetailsMapContainer.module.scss';

function AdDetailsMapContainer() {
  const { activeAd } = useAppSelector(getAdState, shallowEqual);
  const [isSatellite, setIsSatellite] = useState(true);

  const handleBtnClick = () => setIsSatellite(!isSatellite);

  if (!activeAd.result) return null;
  const ad = activeAd.result;

  const buttonContent = !isSatellite ? 'VUE SATELLITE' : 'VUE PLAN';

  return (
    <div className={styles.adDetailsMapContainer}>
      <div className={styles.mapWrapper}>
        <Map
          center={ad.city.coordinates}
          className={styles.map}
          isSatellite={isSatellite}
          markers={<AdMarkers />}
        />
        <MapLegend />
      </div>
      <Button
        btnType="button"
        borderColor="violet"
        bgColor="grey"
        textColor="violet"
        btnContent={buttonContent}
        handleClick={handleBtnClick}
      />
    </div>
  );
}

export default AdDetailsMapContainer;
